'use client';

import ErrorState from '@/components/ErrorState';
import { useT } from '@/hooks/useT';

export default function ActivityError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useT();
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('error.activity.title')}
      description={t('error.activity.desc')}
      section="Activity"
    />
  );
}
